var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyUs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 15H45V7.5C44.999 6.50574 44.6036 5.55249 43.9006 4.84945C43.1975 4.1464 42.2443 3.75099 41.25 3.75H7.5C6.50574 3.75099 5.55249 4.1464 4.84945 4.84945C4.1464 5.55249 3.75099 6.50574 3.75 7.5V41.25C3.75099 42.2443 4.1464 43.1975 4.84945 43.9006C5.55249 44.6036 6.50574 44.999 7.5 45H15V52.5C15.001 53.4943 15.3964 54.4475 16.0994 55.1506C16.8025 55.8536 17.7557 56.249 18.75 56.25H52.5C53.4943 56.249 54.4475 55.8536 55.1506 55.1506C55.8536 54.4475 56.249 53.4943 56.25 52.5V18.75C56.249 17.7557 55.8536 16.8025 55.1506 16.0994C54.4475 15.3964 53.4943 15.001 52.5 15ZM41.25 41.25H26.25V31.875H41.25V41.25ZM41.25 28.125L41.5 18.5L26.25 18.75H41.25V28.125ZM22.5 28.125H7.5V18.75H22.5V28.125ZM41.25 7.5V15H7.5V7.5H41.25ZM7.5 41.25V31.875H22.5V41.25H7.5ZM52.5 52.5H18.75V45H41.25C42.2443 44.999 43.1975 44.6036 43.9006 43.9006C44.6036 43.1975 44.999 42.2443 45 41.25V18.75H52.5V52.5Z",
    fill: "#0F4699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUs2);
export default __webpack_public_path__ + "static/media/WhyUs2.7162e7af3dd44dcd4c05f62965ae42a4.svg";
export { ForwardRef as ReactComponent };